import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[outline]',
    templateUrl: './outline.component.html',
    styleUrl: './outline.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OutlineComponent {

}
